import React from 'react'
import { Tag } from 'antd'
import './TagButton.scss'

const TagButton = ({
  title,
  onClick,
  active,
  amount = 0
}) => {
  return (
    <Tag
      className={`filter-tag ${active ? 'active-tag' : ''}`}
      onClick={onClick}
    >
      {title}
      {!!amount && (
        <div className={'pending-area'}>
          <div className={amount > 99 ? 'pending-notification over-ninety-nine' : 'pending-notification'}>{
            amount > 99 ? `+${99}` : amount}</div>
        </div>
      )}
    </Tag>
  )
}

export default TagButton